import type { ReactNode } from 'react'
import { cn } from '@/shared/lib/utils'

/** Étiquette mono pour références/codes (`RÉSA-2026-0042`) - token V2 `.tag`. */
export function Tag({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-sm border border-[var(--v2-line)] bg-[var(--v2-surface-2)] px-1.5 py-0.5 font-mono text-[12px] tracking-tight text-[var(--v2-ink-2)] [font-feature-settings:"tnum"]',
        className,
      )}
    >
      {children}
    </span>
  )
}
